import { AppThunk } from 'store/types';
import {
  getTaxCertificationRequestsAsyncAction,
  sendToSpruceAsyncAction,
  patchTaxCertificationETAAsyncAction,
} from './slices';

export const updateEtaTaxCertification =
  (orderId: string, taxCertRequestId: string, eta?: string | null): AppThunk =>
  async (dispatch) => {
    await dispatch(patchTaxCertificationETAAsyncAction({ taxCertRequestId, eta }));
    await dispatch(getTaxCertificationRequestsAsyncAction(orderId));
  };

export const sendTaxCertificationToSpruce =
  (orderId: string, taxCertRequestId: string): AppThunk =>
  async (dispatch) => {
    await dispatch(sendToSpruceAsyncAction(taxCertRequestId));
    await dispatch(getTaxCertificationRequestsAsyncAction(orderId));
  };
